export class BusinessFunctionFeatureDto {
    $type:string;
    name: string;
    enabled: boolean;
    featureId: number;
    constructor(featureId: number, type: string) {
        this.$type = type;
        this.featureId = featureId;
    }
}